import React, { useEffect, useState } from "react";
import translate from "../../service/Language";
import classes from "./Reviews.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
function Reviews() {

  const [mediaSlider, setMediaSlider] = useState(3)

  useEffect(() => {
    if (window.innerWidth > 1400) {
      setMediaSlider(3.1)
    } else if (window.innerWidth < 1400) {
      setMediaSlider(3)
      if (window.innerWidth < 1180) {
        setMediaSlider(2.5)
        if (window.innerWidth < 980) {
          setMediaSlider(2)
          if (window.innerWidth < 770) {
            setMediaSlider(1)
          }
        }
      }
    } else {
      setMediaSlider(1)
    }
  }, [])

  const [reviews] = useState([
    {
      img: "/images/2.jpg",
      name_uz: "Madina",
      name_ru: "Мадина",
      message_uz:
        "Buyurtmamni oldim! Ajoyib sifatli Lyulka! Hammasi chiroyli va rasmdagiga to'liq mos keladi! Buyurtma juda tez keldi. Albatta xudo xoxlasa yana zakaz qilaman.",
      message_ru:
        "Я получил свой заказ! Коляска отличного качества! Все красиво и точно как на фото! Заказ прибыл очень быстро. Конечно я буду заказывать еще.",
    },
    {
      img: "/images/1.jpg",
      name_uz: "Sadikova Karina",
      name_ru: "Садыкова Карина",
      message_uz:
        "Ikkinchi marotaba zakaz beraman, sifat menga juda yoqdi, narxlar ajoyib, hatto buyurtma uygacha yetkazildi, men yana buyurtma beraman.",
      message_ru:
        "Второй раз делаю заказ, очень нравится качество, цены отличные,  заказ даже доставили домой спасибо огромное. буду заказывать еще.",
    },
    {
      img: "/images/3.jpg",
      name_uz: "Burkieva Diana",
      name_ru: "Буркиева Диана",
      message_uz:
        `Katta rahmat bizga juda yoqdi
        Sifat shunchaki ajoyib.
        Men rang haqida juda xavotirda edim, lekin aksincha, bu yaxshiroq
        sodir bo'ldi. Mehnatingiz uchun rahmat`,
      message_ru: `Спасибо вам огромное нам очень понравилось
      Качество просто супер.
      Очень сильно переживала за цвет но наоборот  лучше
      получилось.
      Спасибо за ваш труд`,
    },
    {
      img: "/images/4.jpg",
      name_uz: "Sottiyeva Simora",
      name_ru: "Соттиева Симора",
      message_uz:
        "Mehribon shop internet do'konining ishlari judayam chiroyli, sifatli va albatta hamyonbop. Manga juda yoqdi. Olgan lyulkam juda ham qulay, orginal super. Omad",
      message_ru:
        "Работы интернет-магазина Mehriban shop очень красивые и качественные, цены очень дешевые. Мне действительно это понравилось. Люлька мне досталась очень удобная, оригинал супер. Удачи",
    },
  ]);


  return (
    <div className={classes.Reviews_page} id="reviews">
      <h2>
        {translate("Отзывы наших клиентов", "Mijozlarimizdan fikr-mulohazalar")}
      </h2>

      <div className={classes.Reviews}>
        <Swiper
          slidesPerView={mediaSlider}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, Navigation]}
          className="mySwiper"
        >
          {reviews.map((item, index) => (
            <SwiperSlide key={index}>
              <div className={classes.Review}>
                <div className={classes.image}>
                  <img src={item.img} alt="" />
                  <span>{translate(item.name_ru, item.name_uz)}</span>
                  <p>{translate(item.message_ru, item.message_uz)}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default Reviews;
